import { useMemo } from 'react'

import { SanityFilterGroup } from '@data/sanity/queries/types/filter'
import { SanityCollectionStrings } from '@data/sanity/queries/types/strings'
import { Filter, FilterValue } from '@lib/product'
import { UrlParameter } from '@lib/url'

import Accordion from '@components/accordion'
import Icon from '@components/icon'
import CollectionChip from './chip'

interface CollectionFilterChipsProps {
  filterGroups: SanityFilterGroup[]
  activeFilters: Filter[]
  activeFilterValueCount: number
  collectionStrings: SanityCollectionStrings
  onClick: (newParameters: UrlParameter[]) => void
}

const CollectionFilterChips = ({
  collectionStrings,
  filterGroups,
  activeFilters,
  activeFilterValueCount,
  onClick,
}: CollectionFilterChipsProps) => {
  const hasValues = useMemo(
    () => activeFilterValueCount > 0,
    [activeFilterValueCount],
  )
  const activeFilterValues: FilterValue[] = activeFilters.flatMap(
    ({ name, values }) => values.map((value) => ({ name, value })),
  )

  return (
    <div className="flex">
      <Accordion
        id="collection-filter-chips"
        isOpen={hasValues}
        isControlled
        className="w-full border-t-0"
        innerClassName="max-w-none pb-0"
      >
        <div
          className="flex overflow-x-auto no-scrollbar"
          style={{
            WebkitMaskImage:
              'linear-gradient(90deg,transparent 0, #000 1rem, #000 calc(100% - 1rem), transparent)',
            maskImage:
              'linear-gradient(90deg,transparent 0, #000 1rem, #000 calc(100% - 1rem), transparent)',
          }}
        >
          <ul className="p-4 whitespace-nowrap">
            {activeFilterValues.map((filter, index) => {
              const currentValues =
                activeFilters.find(({ name }) => name === filter.name)
                  ?.values || []

              const newValues = currentValues
                .filter((value) => value !== filter.value)
                .join()

              const option = filterGroups
                .find(({ slug }) => slug === filter.name)
                ?.options?.find(({ slug }) => slug === filter.value)

              if (!option) {
                return null
              }

              return (
                <CollectionChip
                  key={index}
                  label={`${collectionStrings.collectionRemoveFilter}: ${option.title}`}
                  title={`${collectionStrings.collectionRemoveFilter}: ${option.title}`}
                  onClick={() =>
                    onClick([
                      {
                        name: filter.name,
                        value: newValues || null,
                      },
                    ])
                  }
                  icon={<Icon id={`remove-chip-${option.slug}`} name="Cross" />}
                  className="mr-2"
                >
                  {option.title}
                </CollectionChip>
              )
            })}
          </ul>
        </div>
      </Accordion>
    </div>
  )
}

export default CollectionFilterChips
